import { put, select, take, cancel } from 'redux-saga/effects';
import { Slider } from '../../../../components/common/Slider';
import { SERVICES_SLIDER_ID } from '../../../../constants/nodeIds';
import { selectActiveRecommendedPackage, selectFirstPackage, selectServiceById, selectServiceIds } from '../../../../selectors/publishTerms';
import {
  EPlacingType,
  IPublishOption,
  loadPublishTerms,
  LOAD_PUBLISH_TERMS_SUCCESS,
  selectPackage,
  selectPlacingType,
  selectPublishTermsService,
} from '../../../reducers';
import { IAppState } from '../../../types';

export function* afterSubscriptionBuy() {
  const state: IAppState = yield select();

  const selectedPeriod = selectActiveRecommendedPackage(state);

  if (!selectedPeriod) {
    yield cancel();

    return;
  }

  const serviceType = selectedPeriod.services.join('+');

  const service = selectServiceById(serviceType, state);

  if (!service) {
    yield cancel();

    return;
  }

  yield put(loadPublishTerms());

  yield take(LOAD_PUBLISH_TERMS_SUCCESS);

  yield put(selectPublishTermsService(serviceType));

  const firstPackage: IPublishOption = yield select(selectFirstPackage);
  const serviceIds: Array<string> = yield select(selectServiceIds);

  if (!firstPackage) {
    yield cancel();

    return;
  }

  const serviceIndex = serviceIds.indexOf(serviceType);

  yield put(selectPlacingType(EPlacingType.package));
  yield put(selectPackage(firstPackage.id));

  Slider.scrollToSlide(SERVICES_SLIDER_ID, serviceIndex);
}
